module.exports = __webpack_public_path__ + "static/coralmuslinorganicmain-bdfac3e29aeccf1c75c8a2ebba5a4aef.png";